/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, NSFD){
	const a = 'is-active';
	const v = 'is-visible';
	const e = 'err';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const $map = location.pathname.split('/');

	const localDecision = () => {
		const siteName = 'nisshin-foods';
		var regExp = new RegExp(`(test\.${siteName}\.co\.jp|copre\.jp|review\.cmsod\.jp|localhost|192\.168\.0\.|192\.168\.11\.|192\.168\.1\.)`, 'g');
		return regExp.test(location.hostname);
	};
	const localLoading = () => {
		var _this = this;
		// ローカル環境ならincludeをAjaxで読み込む
		let $includeComment = $('.container, .contents, .mod-auto, .customer-include').contents().filter(function() {
			return this.nodeType === document.COMMENT_NODE;
		});
		var key = 'inc_';
		var ajaxArray = [];
		var ajaxArrayList = [];
		var i, j;
		let test = [];
		$includeComment.each((idx, ele)=> {
			if(ele.data.indexOf('#include') !== -1) {
				let filePath = ele.data.split('=')[1].replace(/("| )/g, '');
				ajaxArray.push(filePath);
			}
		});
		var ajaxLen = ajaxArray.length;

		if(ajaxLen > 0) {
			for(i=0; i < ajaxLen; i++) {
				ajaxArrayList[i] = $.ajax({
					type: 'GET',
					url: ajaxArray[i],
					dataType: 'html',
					timeout: 5000
				});
			}
			$.when.apply($, ajaxArrayList).done((...args) => {
				var regExp = new RegExp(key);
				for(i=0; i < args.length; i++) {
					var result = args[i];
					var position = $(result[0]).filter(':first').attr('class').split(' ');

					for(j=0; j < position.length; j++) {
						if(position[j].match(regExp)) {
							position = position[j];
							break;
						}
					}
					document.body.innerHTML = document.body.innerHTML.replace('<!--#include virtual="/index/common/include/'+position+'.html" -->', result[0]);
					console.log('Succeeded to read the include file!:', position);
				}
				loadDelayScript();
			});
		} else {
			loadDelayScript();
		}
	};
	const easeScroll = () => {
		$('a[rel="scroll"]').on('click', (event) => {
			var speed = 1200;
			if(/#/.test(event.currentTarget.href)) {
				scrollToObject(event.currentTarget.href, speed);
			}
			return false;
		});
		function scrollToObject(_self, _speed){
			var hash = '#' + _self.split('#')[1];
			var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

			if(hash !== '#pagetop') {
				if(NSFD.va.window.width < NSFD.va.device.sp) {
					pos -= 60;
				} else {
					pos -= 90;
				}
			}

			$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
		}
	};
	const pageTop = () => {
		var $pagetop = $('.footer-pagetop');

		$(window).scroll(function(e){
			var $this = $(e.currentTarget);
			var $footer = $('.footer');
			// var footerPos = $footer.offset().top + $footer.height();
			var thisScroll = $this.scrollTop();
			// var pagetopPos = $this.height() + $footer.height() + thisScroll;

			if(thisScroll > '150') {
				$pagetop.addClass(v);
			} else {
				$pagetop.removeClass(v);
			}
		});
	};
	const headerMenu = () => {
		// スクロール挙動
		const header = $('.header');
		let startPos = 0;
		$(window).scroll((e) => {
			let $this = $(e.currentTarget);
			let thisScroll = $this.scrollTop();

			if(thisScroll >= 200 && thisScroll > startPos){
				header.addClass('is-small');
			} else {
				header.removeClass('is-small');
			}
			startPos = thisScroll;
		});

		//　検索
		const searchBtn = $('.header-search-btn');
		const searchOverlay = $('.header-search-overlay');
		const o = 'is-open';
		searchBtn.on('click', (e) => {
			$('.header-search').addClass(o);
		});
		searchOverlay.on('click', (e) => {
			$('.header-search').removeClass(o);
		})

		// <SP>ヘッダーメニュー開閉
		const menu = $('.header-menu');
		const menuBtn = $('.header-menuBtn');
		const menuOverlay = $('.header-menu-overlay');
		$('.header-menuBtn, .header-menu-overlay').on('click', (e) => {
			menuBtn.toggleClass(a);
			menu.toggleClass(a);
		});
	};

	// <お問い合わせTOP>タブ切り替え(tablet&sp)
	const customerTopTabChange = () => {
		const c = 'is-current';
		const a = 'is-active';
		$('.js-spTab').on('click', (e) => {
			$('.js-spTab').removeClass(c);
			$(e.currentTarget).addClass(c);
			let target = $(e.currentTarget).attr('data-name');
			$('.js-spTab-content').removeClass(a);
			$('div[id="'+ target +'"]').addClass(a);
		});

		// <SP>Match Height
		$('.js-spTab').matchHeight();
	};

	const faqToggle = () => {
		var $list = $('.p-faq-list, .c-more-list');
		$list.on('click', 'dt', function (e) {
			e.preventDefault();
			$(this).toggleClass('is-open');
			$(this).next('dd').slideToggle(200);
		});

		if (location.hash && ($list.find('dt' + location.hash).length > 0)) {
			$list.find('dt' + location.hash).trigger('click');
		}
	};

	// <お問い合わせフォーム> セレクトボックスエラーチェック
	const selectErr = () => {
		$('.c-select').each((idx, ele) => {
			let thisClass = $(ele).attr('class');

			if(thisClass.indexOf('_err') !== -1) {
				let selectFlag = $(ele).val();
				if(selectFlag === '') {
					$(ele).addClass(e);
					$(ele).on('change', (event) => {
						let $this = $(event.currentTarget);
						if($this.val() !== ''){
							$this.addClass('is-selected');
						} else {
							$this.removeClass('is-selected');
						}
					});		
				}
			}
		});
	}

	const recommendSlider = () => {
		// おすすめ商品サイト
		$(document).ready(() => {
			if($('.prod-idx-recommend-slider').length) {
				$('.prod-idx-recommend-slider').slick({
					infinite: true,
					speed: 1500,
					autoplay: true,
					autoplaySpeed: 5000,
					slidesToShow: 4,
					arrows: true,
					dots: false,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								appendArrows: $('.prod-idx-recommend-slider-arrows'),
							}
						}
					]
				});
				$('.mod-boxLink03-txtBlock-tit').matchHeight();
				$('.mod-boxLink03-txtBlock-txt').matchHeight();
				$('.prod-idx-recommend-slider').addClass(v);
			}
		});
	};
	const marsflag = () => {
		var el = document.createElement('script');
		// マーズフラッグ検索窓用js
		el.src = '//c.marsflag.com/mf/mfx/1.0/js/mfx-sbox.js';

		setTimeout(function(){
			document.body.appendChild(el);
		}, 100);
	};

	// -------------------------------------------------------------------------------- //
	const loadDelayScript = () => {
		easeScroll();
		pageTop();
		headerMenu();

		faqToggle();
		recommendSlider();
		marsflag();
		// <FAQ>
		if($('.p-faq-search__content').length) {
			customerTopTabChange();
		}
		// <お問い合わせフォーム> 確認画面のみ発火
		if($map[$map.length -1] == 'confirm.html') {
			selectErr();
		}
	};

	$(() => localDecision() ? localLoading() : loadDelayScript());

})(window.jQuery, window.NSFD);
